export const redCrescent = [
  {
    "id": "63175ddf0e210141e131a09d",
    "name": "درمانگاه شماره 1 (الماس شرق)",
    "coordinates": [
      44.07191667,
      33.01885556
    ]
  },
  {
    "id": "63175ddf0e210141e131a0a1",
    "name": "بیمارستان الحسین",
    "coordinates": [
      44.05327778,
      33.01902222
    ]
  },
  {
    "id": "63175ddf0e210141e131a0a4",
    "name": "درمانگاه شماره ا (نبا)",
    "coordinates": [
      44.54160278,
      32.669825
    ]
  },
  {
    "id": "63175ddf0e210141e131a0a5",
    "name": "درمانگاه شماره 2 هتل ام القرا",
    "coordinates": [
      44.53452778,
      32.66855556
    ]
  },
  {
    "id": "63175ddf0e210141e131a0a6",
    "name": "درمانگاه شماره 3 صحن حضرت زهرا",
    "coordinates": [
      44.52463889,
      32.66647222
    ]
  },
  {
    "id": "63175ddf0e210141e131a0a9",
    "name": "بیمارستان امام علی",
    "coordinates": [
      44.56944444,
      32.65519444
    ]
  },
  {
    "id": "63175ddf0e210141e131a0aa",
    "name": "پایگاه شماره  1 عمود 112",
    "coordinates": [
      44.32413889,
      32.11166667
    ]
  },
  {
    "id": "63175ddf0e210141e131a0ab",
    "name": "پایگاه شماره2عمود 244 بیمارستان امل",
    "coordinates": [
      44.31530556,
      32.1705
    ]
  },
  {
    "id": "63175ddf0e210141e131a0ac",
    "name": "پایگاه شماره 3 عمود 285",
    "coordinates": [
      44.30877778,
      32.18902778
    ]
  },
  {
    "id": "63175ddf0e210141e131a0ad",
    "name": "پایگاه شماره 4 عمود 320 همکاری با عتبه علویه",
    "coordinates": [
      44.30383333,
      32.20386111
    ]
  },
  {
    "id": "63175ddf0e210141e131a0ae",
    "name": "پایگاه شماره 5 عمود 395",
    "coordinates": [
      44.29313889,
      32.23633333
    ]
  },
  {
    "id": "63175ddf0e210141e131a0af",
    "name": "پایگاه شماره 6 عمود 494",
    "coordinates": [
      44.28125,
      32.28008333
    ]
  },
  {
    "id": "63175ddf0e210141e131a0b0",
    "name": "پایگاه شماره 7 عمود 527",
    "coordinates": [
      44.27833333,
      32.2955
    ]
  },
  {
    "id": "63175ddf0e210141e131a0b1",
    "name": "پایگاه شماره 8 عمود 578 بیمارستان حیدریه",
    "coordinates": [
      44.27136111,
      32.31680556
    ]
  },
  {
    "id": "63175ddf0e210141e131a0b2",
    "name": "پایگاه شماره 9  عمود 798",
    "coordinates": [
      44.20544444,
      32.39847222
    ]
  },
  {
    "id": "63175ddf0e210141e131a0b3",
    "name": "پایگاه شماره 10  عمود 952",
    "coordinates": [
      44.16530556,
      32.45872222
    ]
  },
  {
    "id": "63175ddf0e210141e131a0b4",
    "name": "پایگاه شماره 11 عمود 1080",
    "coordinates": [
      44.13044444,
      32.50883333
    ]
  },
  {
    "id": "63175ddf0e210141e131a0b5",
    "name": "پایگاه شماره 12 عمود 1092",
    "coordinates": [
      44.12675,
      32.51288889
    ]
  },
  {
    "id": "63175ddf0e210141e131a0b6",
    "name": "پایگاه شماره 13 عمود 1120",
    "coordinates": [
      44.11719444,
      32.52322222
    ]
  },
  {
    "id": "63175ddf0e210141e131a0b7",
    "name": "پایگاه شماره 14 عمود 1222",
    "coordinates": [
      44.07769444,
      32.55361111
    ]
  },
  {
    "id": "63175ddf0e210141e131a0c4",
    "name": "بیمارستان صحرایی 1",
    "coordinates": [
      46.02055556,
      33.00055556
    ]
  },
  {
    "id": "63175ddf0e210141e131a0c5",
    "name": "بیمارستان صحرایی 2",
    "coordinates": [
      46.05627222,
      33.11846389
    ]
  },
  {
    "id": "63175ddf0e210141e131a0c6",
    "name": "بیمارستان صحرایی 3",
    "coordinates": [
      46.13697222,
      33.14583333
    ]
  },
  {
    "id": "63175ddf0e210141e131a0c7",
    "name": "بیمارستان صحرایی دانشگاه",
    "coordinates": [
      46.20058333,
      33.09897222
    ]
  }
];